module.exports = __webpack_public_path__ + "img/a2.50a8bb2.png";